import { dispatch } from '../internal';
import * as actionTypes from './actionTypes';
export const toggleLeftNav = () => dispatch({ type: actionTypes.TOGGLE_LEFT_NAV_OPEN });
export const toggleRightNav = () => dispatch({ type: actionTypes.TOGGLE_RIGHT_NAV_OPEN });
//# sourceMappingURL=actions.js.map